export const numberFormatter = new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
});
